import { Divider, Paper, Stack, SxProps, Theme, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FunctionComponent, ReactElement, ReactNode } from 'react';
import ExportButton from './ExportButton';
import './index.scss';

interface DashboardItemProps {
	title: ReactNode;
	children?: ReactNode;
	exportLabel?: string;
	onExport?: () => void;
	sx?: SxProps<Theme>;
}

const DashboardItem: FunctionComponent<DashboardItemProps> = ({
	title,
	children,
	exportLabel,
	onExport,
	sx,
}): ReactElement => (
	<Paper className="dashboard-item" sx={{ padding: 3, ...sx }}>
		<Stack direction="row" justifyContent="space-between">
			<Typography component="h2" variant="h5">
				{title}
			</Typography>
			{onExport && <ExportButton label={exportLabel ?? ''} type="secondary" onClick={onExport} />}
		</Stack>
		<Box component={Divider} mt={3} mb={4} className="dashboard-item-content" />
		{children}
	</Paper>
);

export default DashboardItem;
